import React from 'react';
import styled from '@emotion/styled';
import { useStaticQuery, graphql } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import AnimatedSection from '../../components/AnimatedSection';
import CommonSection from "../../components/CommonSection";
import { parseHTML } from '../../functions/common'
import * as breakpoint from '../../styles/breakpoints.module.scss';
import RoundButton from '../../components/RoundButton';

const CampaignSection = () => {
  const { t } = useLocalization();
  const data = useStaticQuery(graphql`
    query FrameStickerCampaign {
      gpose_1 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_1.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_2 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_2.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_3 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_3.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_4 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_4.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_5 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_5.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_6 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_6.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
    }
  `);


  return (
    <React.Fragment>
      <AnimatedSection>
        <CommonSection>
          <ContentFrame>
            <Deco className="image_1">
              <GatsbyImage image={getImage(data[`gpose_2`])} alt="" />
            </Deco>
            <Deco className="image_2">
            <GatsbyImage image={getImage(data[`gpose_3`])} alt="" />
            </Deco>
            <TitleText>
              {parseHTML(t('frame_sticker.campaign.title'))}
            </TitleText>
            <DescText>
              {parseHTML(t('frame_sticker.campaign.text'))}
            </DescText>
            <DetailsButton color={'#F50057'} size={'medium'} href={t('frame_sticker.campaign.button.url')} >
              {t('frame_sticker.campaign.button.label')}
            </DetailsButton>
          </ContentFrame>
        </CommonSection>
      </AnimatedSection>
    </React.Fragment>
  );
}
 
export default CampaignSection;

const ContentFrame = styled.div`
  max-width:1344px;
  width:100%;
  margin:0 auto;
  padding: 96px 64px;
  background: #FCFCFF;
  border: 8px solid #D00F31;
  box-sizing: border-box;
  border-radius: 12px;
  text-align:center;
  position:relative;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding: 64px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding: 24px;
  }
`

const DetailsButton = styled(RoundButton)`
  padding:16px 32px;
  font-size: 28px;
  height:auto;
  line-height: 32px;
  border-radius:32px;
  box-shadow: 0px 6px 8px -4px rgba(255, 54, 78, 0.5);

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:12px 24px;
    height:auto;
    font-size: 17px;
    line-height: 24px;
    border-radius: 24px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:8px 16px;
    height:auto;
    font-size: 14px;
    line-height: 20px;
  }
`;

const TitleText = styled.div`
  max-width: 928px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom:46px;

  font-weight: 900;
  font-size: 48px;
  line-height: 56px;
  color: #2C2C2E;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 28px;
    line-height: 36px;
    margin-bottom:32px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 16px;
  }
`

const DescText = styled.div`
  font-size: 20px;
  line-height: 32px;
  color: #444448;
  margin-bottom:46px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 16px;
    line-height: 28px;
    margin-bottom: 32px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`

const Deco = styled.div`
  position:absolute;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  border-radius: 2px;
  
  /* Shadow / 1dp */
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);

  &.image_1{
    width:320px;
    transform: rotate(15deg);
    top:-32px;
    right:-64px;
  }
  &.image_2{
    width:208px;
    transform: rotate(-15deg);
    left:-32px;
    bottom:-20px
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    &.image_1{
      width:176px;
      right:-40px;
    }
    &.image_2{
      width:128px;
      left:-16px;
      bottom:-16px
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    &.image_1{
      width:112px;
    }
    &.image_2{
      width:72px;
      bottom:-24px
    }
  }
`
